(<template>
  <page-data-section :title="sectionTitle"
                     :description="sectionDescription"
                     :progress="progressActive"
                     :class="{'in-progress': progressActive}"
                     class="compliance">
    <div class="compliance__content">
      <div>
        <a v-if="termsLink"
           :href="termsLink"
           target="_blank"
           class="compliance__link">{{ linkText }}</a>
        <p class="compliance__status">{{ consentStatus }}</p>
      </div>
      <button class="sk-btn compliance__button"
              :class="{
                'sk-btn--white': isAcceptedStatus,
                'sk-btn--default': !isAcceptedStatus
              }"
              @click="handleCompliance">{{ buttonText }}</button>
    </div>
  </page-data-section>
</template>)

<script>
  import {mapGetters} from 'vuex';
  import PageDataSection from '@/components/shared_components/page_data/PageDataSection';

  export default {
    components: {
      'page-data-section': PageDataSection
    },
    data() {
      return {
        progressActive: false,
      };
    },
    computed: {
      ...mapGetters('UserInfoStore', [
        'userUid',
        'folkeregisterConsentStatus',
        'folkeregisterConsentPopupCounter'
      ]),
      consentStatus() {
        const status = this.folkeregisterConsentStatus;
        return status.charAt(0).toUpperCase() + status.slice(1);
      },
      isAcceptedStatus() { return this.folkeregisterConsentStatus === 'accepted'; },
      sectionTitle() { return this.$gettext('Consent for retrieving information'); },
      sectionDescription() {
        const template = this.$gettext('To continue receiving on-site assignment requests from %{domain}, we need your consent to retrieve data from the National Population Register. Please accept the National Population Register’s terms and conditions if you wish to receive on-site assignments through %{domain}.');
        return this.$gettextInterpolate(template, {domain: this.$getString('domainData', 'platformName')});
      },
      termsLink() { return this.$getString('domainData', 'termLink'); },
      linkText() { return this.$gettext('Terms and Conditions'); },
      buttonText() { return this.isAcceptedStatus ? this.$gettext('Retract consent') : this.$gettext('Accept'); },
    },
    methods: {
      sendFolkeregisterConsent(status) {
        this.progressActive = true;
        const params = {
          folkeregisterConsent: {
            folkeregisterConsentStatus: status,
            folkeregisterConsentPopupCounter: this.folkeregisterConsentPopupCounter,
          }
        };
        this.$store.dispatch('sendFolkeregisterConsent', params).then(() => {
          this.$store.dispatch('UserInfoStore/fetchUserInfo', this.userUid).then(() => {
            this.progressActive = false;
          });
        });
      },
      handleCompliance() {
        if (!this.isAcceptedStatus) {
          this.sendFolkeregisterConsent('accepted');
        } else {
          this.$store.commit('ModalStore/setModal', {
            component: 'retract-compliance-modal',
            width: 480,
            data: {
              context: this,
              modalCallback: this.sendFolkeregisterConsent
            }
          });
        }
      }
    }
  };
</script>

<style scoped>
  .compliance__content {
    display: flex;
    justify-content: space-between;
  }

  .compliance__link {
    text-decoration: underline;
  }

  .compliance__status {
    color: #666;
  }

  .compliance__button {
    width: fit-content;
    padding: 0 12px;
  }
</style>
